import React, { Fragment, useEffect, useRef } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles((theme) => ({}));

function Eyepiece3Resource() {
  const classes = useStyles();

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={7}>
        <Typography variant="h6" gutterBottom>
          Institutional Narrative
        </Typography>
        <ul>
          <li>
            <Link
              href="https://julianagyeman.com/2014/05/18/storying-institutions-understanding-things/"
              variant="subtitle1"
              target="_blank"
            >
              Storying Institutions Understanding Things
            </Link>
            <Typography variant="body2">
              A great overview of institutional storytelling with solid examples
            </Typography>
          </li>
          <li>
            <Link
              href="https://www.edelements.com/blog/is-marketing-your-school-district-a-thing-part-2-storytelling"
              variant="subtitle1"
              target="_blank"
            >
              Marketing Your School District
            </Link>
            <Typography variant="body2">
              This resource shares excellent points of why telling your district
              story is necessary for branding and how
            </Typography>
          </li>
          <li>
            <Link
              href="https://www.canadianlawyermag.com/news/opinion/the-importance-of-institutional-narrative/274764"
              variant="subtitle1"
              target="_blank"
            >
              The Importance of Institutional Narrative
            </Link>
            <Typography variant="body2">
              The lawyer makes a strong case for why an institutional narrative
              is a critical component of your brand
            </Typography>
          </li>
          <li>
            <Link
              href="https://www.betterevaluation.org/en/plan/approach/institutional_histories"
              variant="subtitle1"
              target="_blank"
            >
              Institutional Histories
            </Link>
            <Typography variant="body2">
              This resource outlines a institutional history document and why it
              is necessary
            </Typography>
          </li>
          {/* <li>
            <Link
              href="https://journals.openedition.org/ilcea/4677"
              variant="subtitle1"
              target="_blank"
            >
              Narrative, Identity and Academics
            </Link>
          </li> */}
        </ul>
        <Typography variant="h6" gutterBottom>
          Strategic Narrative
        </Typography>
        <ul>
          <li>
            <Link
              href="https://hbr.org/2016/03/how-to-build-a-strategic-narrative"
              variant="subtitle1"
              target="_blank"
            >
              Building a Strategic Narrative
            </Link>
            <Typography variant="body2">
              Learn how to embed specific components into your strategic
              narrative for a solid foundation
            </Typography>
          </li>
          {/* <li>
            <Link
              href="https://www.slideshare.net/gmurrel/building-a-strategic-narrative-messaging-framework"
              variant="subtitle1"
              target="_blank"
            >
              Messaging Framework for your Narrative
            </Link>
          </li> */}
          <li>
            <Link
              href="https://engageforsuccess.org/strategic-leadership/hints-tips-developing-a-strategic-narrative/"
              variant="subtitle1"
              target="_blank"
            >
              Strategic Leadership
            </Link>{" "}
            <Typography variant="body2">
              A step by step guide with hints & tips for developing your
              strategic narrative
            </Typography>
          </li>
          {/* <li>
            <Link
              href="https://www.forbes.com/sites/chriscancialosi/2015/05/04/the-strategic-narrative-a-better-way-to-communicate-change/?sh=12c4e7427787"
              variant="subtitle1"
              target="_blank"
            >
              A Better Way to Communicate
            </Link>
          </li> */}
          <li>
            <Link
              href="https://lessonbucket.com/media-in-minutes/media-in-minutes-vce-media-edition-narrative-and-ideology-writing-about-context/"
              variant="subtitle1"
              target="_blank"
            >
              Writing about Context
            </Link>{" "}
            <Typography variant="body2">
              Check out this video on writing about context in relation to
              Narrative and Ideology
            </Typography>
          </li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Storytelling
        </Typography>
        <ul>
          <li>
            <Link
              href="https://www.storycenter.org"
              variant="subtitle1"
              target="_blank"
            >
              Storycenter
            </Link>
            <Typography variant="body2">
              Listen deeply. Tell Stories. Excellent resources for workshops,
              events and stories
            </Typography>
          </li>
          <li>
            <Link
              href="https://www.schoolwebmasters.com/Blog_Articles?entityid=395412"
              variant="subtitle1"
              target="_blank"
            >
              Successful School Marketing
            </Link>{" "}
            <Typography variant="body2">
              Use your schools story as a secret weapon for successful
              marketing. Excellent examples and resources
            </Typography>
          </li>
          {/* <li>
            <Link
              href="https://www.k12insight.com/trusted/telling-story-school-marketing/"
              variant="subtitle1"
              target="_blank"
            >
              Telling Your School Story
            </Link>
          </li> */}
        </ul>
        <Typography variant="h6" gutterBottom>
          Data Selfie
        </Typography>
        <ul>
          <li>
            <Link
              href="https://ideas.ted.com/how-to-draw-your-own-selfie-using-your-personal-data/"
              variant="subtitle1"
              target="_blank"
            >
              Draw Your Own Selfie
            </Link>
            <Typography variant="body2">
              TED presenter that talks about generating a data- driven
              perspective
            </Typography>
          </li>
          <li>
            <Link
              href="http://giorgialupi.com/data-portraits-at-ted2017"
              variant="subtitle1"
              target="_blank"
            >
              Data Portraits
            </Link>
            <Typography variant="body2">
              The inspiration for our data selfie - TED inspired
            </Typography>
          </li>
          <li>
            <Link
              href="https://vcg.seas.harvard.edu/publications/dataselfie-empowering-people-to-designpersonalized-visuals-to-represent-their-data/paper"
              variant="subtitle1"
              target="_blank"
            >
              Design Personalized Visuals to Represent their Data
            </Link>
            <Typography variant="body2">
              A deeper look into the previous links with data and data portraits
            </Typography>
          </li>
        </ul>
      </Grid>
      <Grid item xs={12} md={5}>
        <Box className={classes.videoContainer}>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/sczwFnO7A5I"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </Box>
      </Grid>
    </Grid>
  );
}

export default Eyepiece3Resource;
